/**
 * 404 / No match on route...
 * TODO - make it prettier
 */
import React from 'react'

const NoMatch = () => (
  <div>
    <h3 style={{ margin: '1em' }}>Ah snap! File not found.</h3>
  </div>
)

export default NoMatch
